import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import AuthShell, { Field, Input } from "../components/AuthShell";

export default function ForgotPassword() {
  const [identifier, setIdentifier] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { identifier });
      setSent(true);
      toast.success("If an account matches, a reset link has been sent.");
    } catch { toast.error("Could not process request"); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Forgot Password" subtitle="We'll send a reset link" footer={<Link to="/login" className="hover:text-[var(--accent)]">← Back to login</Link>}>
      {sent ? (
        <div data-testid="forgot-sent" className="text-sm text-[var(--muted)]">
          <p className="mb-3">If an account matches that email or phone, we've sent a reset link valid for 1 hour.</p>
          <p className="italic">Tip: while real email is being wired up, the link is also visible in the admin's "Email Outbox".</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="Email or Mobile Number">
            <Input required value={identifier} onChange={e=>setIdentifier(e.target.value)} placeholder="you@example.com or +971 50 ..." data-testid="forgot-identifier" />
          </Field>
          <button type="submit" disabled={loading}
            className="btn-gold w-full rounded-full py-3 text-sm tracking-widest uppercase disabled:opacity-60" data-testid="forgot-submit">
            {loading ? "Sending..." : "Send Reset Link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
